import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { Pie } from "vue-chartjs";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ArcElement,
  Colors,
} from "chart.js";
import { computed, ref } from "vue";
import ChartDataLabels from "chartjs-plugin-datalabels";


export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    compliant: null,
    nonCompliant: null
  },
  setup(__props: any) {

const props = __props as { title: string; compliant: number; nonCompliant: number }

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ArcElement,
  Colors,
  ChartDataLabels
);


function percentageFormatter(value: number, ctx: any) {
  let sum = 0;
  let dataArr = ctx.chart.data.datasets[0].data;
  dataArr.map((data: number) => {
    sum += data;
  });
  let percentage = ((value * 100) / sum).toFixed(2) + "%";
  return percentage;
}

const chartData = computed(() => ({
  labels: ["Cumplimiento", "Incumplimiento"],
  datasets: [{ data: [props.compliant, props.nonCompliant] }],
}));

const options = computed(() => ({
  plugins: {
    title: {
      display: true,
      text: props.title,
    },
    legend: {
      position: "bottom",
    },
    datalabels: {
      formatter: percentageFormatter,
      color: "#fff",
      labels: {
        title: {
          font: {
            weight: "bold",
          },
        },
      },
    },
  },
}));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(Pie), {
      data: _unref(chartData),
      options: _unref(options)
    }, null, 8, ["data", "options"])
  ]))
}
}

})